export const isTranslated = ({ showOriginal }) => !showOriginal;
